/*
 * Copyright (c) Castle Point Learning Systems Corporation, 2013-2023, all rights reserved.
 * NOTICE: Dissemination of the information and/or materials contained in this file is strictly
 * forbidden unless prior written permission is obtained from Castle Point Learning Systems Corporation.
 * See LICENSE.txt (part of this package) for the full notice.
 */
import styled from 'styled-components';
export function getColor(status) {
    switch (status) {
        case 'success':
            return 'rgb(98,147,0)';
        case 'warning':
            return 'rgb(255,152,34)';
        case 'error':
            return 'rgb(255,0,0)';
        case 'unknown':
            return 'rgb(96,96,96)';
        case 'noproblem':
            return;
        case 'hint':
            return 'rgb(49,199,255)';
    }
}
// eslint-disable-next-line no-undef,no-mixed-operators
const Line = styled.div `
    margin-left: ${({ $shift }) => `${$shift}px`};
    margin-bottom: 5px;
    opacity: ${({ $visible }) => ($visible ? '1' : '0')};
`;
const EvaluationComponent = styled.div `
    display: flex;
    justify-content: space-between;
`;
const Evaluation = styled.div `
    padding: 20px;
    flex-grow: 1;
`;
const RemoveBtn = styled.div `
    cursor: pointer;
    font-size: 25px;
    color: red;
    transform: rotate(45deg);
    height: 20px;
    width: 20px;
`;
const Button = styled.div `
    margin-top: 10px;
    padding: 20px 40px;
    cursor: pointer;
`;
const Add = styled(Button) `
    background-color: rgba(0, 0, 0, 0.02);
    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }
`;
const Clear = styled(Button) `
    background-color: rgba(253, 113, 0, 0.1);

    &:hover {
        background-color: rgba(253, 113, 0, 0.2);
    }
`;
const Popover = styled.div `
    position: absolute;
    background-color: white;
    padding: 15px 30px;
    border-radius: 5px;
    border: 1px solid ${({ $status }) => getColor($status)};
    z-index: 1;
    color: ${({ $status }) => getColor($status)};
    max-width: 800px;
`;
const HintBtn = styled.div `
    color: ${({ $status }) => ($status ? getColor($status) : 'rgb(93,93,93)')};
    font-size: 16px;
    display: flex;
    gap: 5px;
    padding: 5px;
    cursor: pointer;
    width: fit-content;

    opacity: 0.7;
    &:hover {
        opacity: 1;
    }
`;
const Row = styled.div `
    padding-bottom: 5px;
`;
const Ltx = styled.span `
    padding: 5px;
    text-wrap: nowrap;
`;
export const Styled = {
    Line,
    EvaluationComponent,
    Evaluation,
    Add,
    Clear,
    RemoveBtn,
    Popover,
    HintBtn,
    Row,
    Ltx,
};
